import {IController} from "angular";
import {UserSettings} from "modules/user_settings/model/UserSettings";
import {UserSettingsService, UserSettingsServiceName} from "modules/user_settings/service/UserSettingsService";
import {ToneOption} from "modules/user_settings/component/email-settings/email-tone-row/email-tone-row";

export interface ToneOptionBlock {
    groupName: string;
    toneOptions: Array<ToneOption>
    selectedValue: string;
}

export interface LengthOption {
    label: string;
    value: string;
}

export class SmsSettingsController implements IController {
    public updatedSettings: UserSettings;
    public static instance = [
        UserSettingsServiceName,
        "settings",
        "$sce",
        SmsSettingsController,
    ];


    constructor(private userSettingsService: UserSettingsService,
                private settings: UserSettings) {
        this.updatedSettings = this.userSettingsService.cloneSettings(this.settings);
    }

}
